// extracted by mini-css-extract-plugin
module.exports = {"headingDiv":"AssignmentHeading_headingDiv__36BQs"};